import zonedTimeToUtc from 'date-fns-tz/zonedTimeToUtc';

const getZonedUTCDate = (
  timeZone: string | null = null,
  date: Date = new Date(),
): Date => zonedTimeToUtc(date, timeZone);

export default getZonedUTCDate;
